import queryString from 'query-string';
import http from '../httpConfig';
import { List } from '../interfaces/role.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listRoles}?${queryString.stringify(paging)}`;
  return http.post(url, { search: searchText });
};

const lookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupRoles}?${queryString.stringify({search: payload.searchText})}`;
  return http.get(url);
};

const RoleService = {
  list,
  lookup
};

export default RoleService;
